import { cargoes } from '../entities/cargoes-sidecar'
import { stacks } from '../entities/stacks-sidecar'
import { IMachine } from '../machines/machines'
import { scene } from '../main/scene-sidecar'
import { tileMapShip } from '../tiles/tileMapShip-sidecar'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'
import { tilesShip } from '../tiles/tilesShip-sidecar'
import { machines } from '../machines/machines-sidecar'

export const createHullOutline = (
  x: number,
  y: number,
  w: number,
  h: number,
) => {
  let ctx = scene.getContext()
  let std = tilesDataShip.getStandard()

  for (let j = 0; j < h; j++) {
    for (let i = 0; i < w; i++) {
      let t = tileMapShip.getTile(ctx.mapShip, i + x, j + y)
      if (t) {
        if (j === 0 || j === h - 1 || i === 0 || i === w - 1) {
          tilesShip.setFloor(t, std.hull)
        } else {
          tilesShip.setFloor(t, std.floor)
        }
      }
    }
  }
}
export const createLadder = (x: number, y: number, w: number, h: number) => {
  let ctx = scene.getContext()
  let std = tilesDataShip.getStandard()

  for (let j = 0; j < h; j++) {
    for (let i = 0; i < w; i++) {
      let t = tileMapShip.getTile(ctx.mapShip, i + x, j + y)
      if (t) {
        tilesShip.setFloor(t, std.tube)
      }
    }
  }
}

export const addCargoToStack = (mc: IMachine, num: number) => {
  let ctx = scene.getContext()

  stacks.ensureStack(mc)

  for (let i = 0; i < num; i++) {
    let cg = cargoes.create(mc.holdsType)
    cargoes.moveToTile(cg, ctx.mapShip, mc.i, mc.j)
    stacks.addToStack(mc, cg)
  }
}

export const createBasicShip = (x: number, y: number) => {
  let ctx = scene.getContext()

  let w = 20
  let h = 5
  let std = tilesDataShip.getStandard()

  createHullOutline(x, y, w, h)

  let mc = machines.create('airlock2')
  machines.moveToTile(mc, ctx.mapShip, x + 1, y + 3)

  let t = tileMapShip.getTile(ctx.mapShip, x + 2, y + 1)
  if (t) {
    tilesShip.setFloor(t, std.hull)
  }

  mc = machines.create('suits')
  machines.moveToTile(mc, ctx.mapShip, x + 3, y + 3)

  mc = machines.create('o2gen-em')
  machines.moveToTile(mc, ctx.mapShip, x + 17, y + 3)
}
